import React from 'react'
import loadImage from 'image-promise';
import cubicInOut from 'eases/cubic-in-out';
import animate from '../utils/animate';
import wait from '../utils/wait';
import hintImg from '../images/360.svg'

let Impetus;

if (typeof window !== `undefined`) {
  Impetus = require('impetus');
}

export default class ThreeSixty extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      loading: true,
      isHintVisible: true
    };
  }

  componentDidMount() {
    if (typeof window === `undefined`) {
      return;
    }
    this._ismounted = true
    const {frames, timeout} = this.props;
    Promise.all([
      wait(timeout),
      loadImage(frames)
      .then((result) => {
        this.setState({ loading: false });
      })
    ])
    .then(() => {
      return animate(0, 57, 2000, cubicInOut, (frame) => {
        this.setCurrentFrame(Math.floor(frame));
      });
    })
    .then(() => {
      if (this._ismounted) {
        new Impetus({
          source: this.container,
          update: (x, y) => {
            this.setState({ isHintVisible: false });
            this.setCurrentFrame(57 + Math.floor(x / window.innerWidth * frames.length));
          }
        });
      }
    });
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  setCurrentFrame(frame) {
    const {frames} = this.props
    const length = frames.length
    let current = frame

    while (current < 0) {
      current = current + length
    }

    while (current > length - 1) {
      current = current - length
    }

    if (current !== this.state.current) {
      this.setState({ current })
    }
  }

  render() {
    const { frames, classModifier } = this.props;
    const { loading, current, isHintVisible } = this.state;

    return (
      <div className="threesixty" ref={(el) => this.container = el}>
        {
          current <= frames.length - 1 &&
            frames.map((frame, i) =>
              <img className={`threesixty--catalog__image ${i === current ? "" : "hidden"}`} src={frame} />
            )
        }
        {
          !loading && isHintVisible && frames.length > 1 &&
            <img className="threesixty__hint" src={hintImg} />
        }
        {
          loading &&
            <div className="threesixty__loading">
              <div className="threesixty__loading__rect1"></div>
              <div className="threesixty__loading__rect2"></div>
              <div className="threesixty__loading__rect3"></div>
              <div className="threesixty__loading__rect4"></div>
              <div className="threesixty__loading__rect5"></div>
            </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ThreeSixty.js